import { BITSTRING_LENGTH } from '../../constants';
import { findFreeSlots } from '../../time/timeUtils';
import { Appointment, Employee, Service } from '../../types';

export const EMPLOYEE_SCHEDULE_STALE_TIME = 1000 * 60 * 5;
export const CARD_ELIGIBILITY_STALE_TIME = 1000 * 60 * 5;
export const FULLY_BOOKED_DAY = '1'.repeat(BITSTRING_LENGTH);

export const getEmployeeLabel = (employee: Employee | null): string =>
  employee ? `${employee.firstName} ${employee.lastName}`.trim() : '';

export const getServicesByIds = (
  serviceRecords: Appointment['servicesList'] | undefined,
  services: Service[],
): Service[] => {
  if (!serviceRecords?.length) {
    return [];
  }

  return serviceRecords
    .map((serviceRecord) => services.find((service) => service.id === serviceRecord.id))
    .filter((service): service is Service => !!service);
};

export const getEligibleEmployeesForServices = (
  servicesList: Service[],
  employees: Employee[],
): Employee[] => {
  if (!servicesList.length) {
    return employees;
  }

  return employees.filter((employee) =>
    servicesList.every((service) => service.employees.includes(employee.id))
  );
};

export const getUnionSlotsForSchedules = (
  scheduleMaps: Map<string, string>[],
  appointmentDuration: number,
): Map<string, string[]> => {
  const slotsByDate = new Map<string, string[]>();
  const dateKeys = new Set<string>();

  scheduleMaps.forEach((scheduleMap) => {
    scheduleMap.forEach((_value, key) => dateKeys.add(key));
  });

  Array.from(dateKeys).forEach((dateKey) => {
    const unionSlots = new Set<string>();
    scheduleMaps.forEach((scheduleMap) => {
      const bitString = scheduleMap.get(dateKey) ?? FULLY_BOOKED_DAY;
      findFreeSlots(bitString, appointmentDuration).forEach((slot) => unionSlots.add(slot));
    });
    slotsByDate.set(dateKey, Array.from(unionSlots).sort());
  });

  return slotsByDate;
};

export const buildAnyAvailableSchedulePlaceholder = (
  slotsByDate: Map<string, string[]> | null,
): Map<string, string> => {
  return new Map(
    (slotsByDate ? Array.from(slotsByDate.keys()) : []).map((dateKey) => [dateKey, FULLY_BOOKED_DAY])
  );
};

export const shouldAllowAnyAvailable = (
  variant: 'customer' | 'internal',
  preferredEmployeeId: string | undefined,
  allowAnyAvailableEmployeePreference: boolean,
): boolean => {
  return variant === 'customer' && !preferredEmployeeId && allowAnyAvailableEmployeePreference;
};
